import { jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import cn from "../../../../vendor/classnames/index.js";
const CalendarButton = ({
  selected,
  current,
  children,
  onClick,
  variant = "dates",
  id,
  disabled
}) => /* @__PURE__ */ jsx(
  Stack,
  {
    id: id ? id + "" : void 0,
    sx: [
      styles.button,
      variant === "dates" ? styles.buttonRound : styles.buttonCommon
    ],
    component: "button",
    className: cn(
      selected && SELECTED_CLASSNAME,
      current && CURRENT_DATE_CLASSNAME
    ),
    onClick,
    disabled,
    children
  }
), SELECTED_CLASSNAME = "selected", CURRENT_DATE_CLASSNAME = "current-date", styles = {
  buttonRound: {
    "--size": "36px",
    borderRadius: "50%",
    width: "var(--size)",
    height: "var(--size)"
  },
  buttonCommon: {
    width: "100%",
    height: "42px"
  },
  button: {
    "--default-color": "transparent",
    "--hover-color": (t) => t.palette.picker.primary.segment.normal.bg.hover,
    "--selected-color": (t) => t.palette.picker.primary.segment.selected.bg.default,
    "--selected-hover-color": (t) => t.palette.picker.primary.segment.selected.bg.hover,
    "--current-date-color": (t) => t.palette.picker.primary.segment.current.bg.default,
    "--current-date-hover-color": (t) => t.palette.picker.primary.segment.current.bg.hover,
    //
    fontFamily: (t) => t.typography.fontFamily,
    color: (t) => t.palette.picker.primary.content,
    fontSize: "14px",
    fontWeight: 500,
    border: "none",
    backgroundColor: "var(--default-color)",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    "@media(hover:hover)": {
      "&:hover:enabled": {
        backgroundColor: "var(--hover-color)"
      }
    },
    [`&.${CURRENT_DATE_CLASSNAME}`]: {
      backgroundColor: "var(--current-date-color)",
      "@media(hover:hover)": {
        "&:hover:enabled": {
          backgroundColor: "var(--current-date-hover-color)"
        }
      }
    },
    [`&.${SELECTED_CLASSNAME}`]: {
      backgroundColor: "var(--selected-color)",
      "@media(hover:hover)": {
        "&:hover:enabled": {
          backgroundColor: "var(--selected-hover-color)"
        }
      }
    },
    ":disabled": {
      color: (t) => t.palette.grey[500]
    }
  }
};
export {
  CalendarButton
};
//# sourceMappingURL=CalendarButton.js.map
